import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Actions = styled.div`
  position: absolute;
  background: white;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  min-width: 130px;
  right: 0;
  & a {
    color: #373737;
    display: block;
    padding: 5px;
  }

  & a:hover {
    font-weight: bold;
  }
`;
